exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".value[data-v-3ff96369] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 50px;\n  min-width: 200px;\n}\n.value .title[data-v-3ff96369] {\n  margin-right: 15px;\n}\n.value input[data-v-3ff96369] {\n  height: 30px;\n}\n.value[data-v-3ff96369] .control-lookup-editor .selected-items {\n  padding-right: 30px;\n}\n", ""]);

// exports
